import { LOAD_LOCALIZATIONS } from "./actionTypes";

export const loadLocalization = localizations => ({
    type: LOAD_LOCALIZATIONS,
    localizations
});
